<template>
  <v-tooltip
    v-bind="{ ...$props, ...$attrs }"
    max-width="208px"
    :location="location"
    :activator-props="activatorProps"
    scroll-strategy="close"
    :open-delay="300"
  >
    <template
      #activator="{ props: hover }"
    >
      <span v-bind="hover">
        <slot name="activator" />
      </span>
    </template>
    <slot />
    <div class="tooltip-caret" :class="location" />
  </v-tooltip>
</template>

<script setup>
defineProps({
  location: {
    type: String,
    default: 'top',
  },
  activatorProps: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style lang="less" scoped>
.v-tooltip > :deep(.v-overlay__content) {
  box-shadow: 0px 0px 6px 0px fade(@text-darkest, 25%);
  background: @white !important;
  opacity: 1 !important;
  z-index: 10 !important;
  padding: 8px !important;
  border-radius: 4px;
  text-align: center;
}

.tooltip-caret {
  position: absolute;
  width: 0;
  height: 0;

  &.top {
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid @white;
  }

  &.bottom {
    top: -5px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid @white;
  }

  &.start, &.left {
    top: 50%;
    right: -5px;
    transform: translateY(-50%);
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid @white;
  }

  &.end, &.right {
    top: 50%;
    left: -5px;
    transform: translateY(-50%);
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid @white;
  }
}
</style>
